import type { PayPalShippingAddressSource } from '../../interfaces';

export const getShippingAddress = (shipping?: PayPalShippingAddressSource | null) => {
  if (!shipping?.addressLine1 || !shipping.postcode) {
    return undefined;
  }

  return {
    firstName: shipping.firstName || undefined,
    lastName: shipping.lastName || undefined,
    addressLine1: shipping.addressLine1,
    addressLine2: shipping.addressLine2 || undefined,
    city: shipping.city || undefined,
    province: shipping.province || undefined,
    postcode: shipping.postcode,
    country: shipping.country || undefined,
    telephone: shipping.telephone || undefined,
    phoneCode: shipping.phoneCode || undefined,
    emoji: shipping.emoji || undefined,
    useAddressForBilling: shipping.useAddressForBilling ?? true,
  };
};
